/**
 * created by lzy 2020/07/07
 * 取消签发时跨版转版稿件提示
 */
'use strict';
angular.module('acrossAlertModule', []).controller('acrossAlertCtrl', ['$scope', '$modalInstance', 'items',
    function($scope, $modalInstance, items) {
        initData();

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            $scope.data = {
                items: items
            };
        }

        /**
         * [cancel description] 取消方法
         *
         * @return  {[type]}   [return description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function(item) {
            item.TITLE = $('<div>' + item.TITLE + '</div>').text();
        };

        /**
         * [confirm description] 确定方法
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function() {
            $modalInstance.close();
        };
    }
]);
